var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.544839 21.7198C0.15172 21.3463 0.15172 20.7407 0.544839 20.3671L10.4028 11L0.544838 1.63289C0.151719 1.25934 0.151719 0.653706 0.544838 0.280159C0.937956 -0.0933857 1.57533 -0.0933858 1.96845 0.280159L13.25 11L1.96845 21.7198C1.57533 22.0934 0.937957 22.0934 0.544839 21.7198Z",
    fill: "url(#paint0_linear_2063_28548)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5448 21.7198C11.1517 21.3463 11.1517 20.7407 11.5448 20.3671L21.4028 11L11.5448 1.63289C11.1517 1.25934 11.1517 0.653706 11.5448 0.280159C11.938 -0.0933857 12.5753 -0.0933858 12.9684 0.280159L24.25 11L12.9684 21.7198C12.5753 22.0934 11.938 22.0934 11.5448 21.7198Z",
    fill: "url(#paint1_linear_2063_28548)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5448 21.7198C22.1517 21.3463 22.1517 20.7407 22.5448 20.3671L32.4028 11L22.5448 1.63289C22.1517 1.25934 22.1517 0.653706 22.5448 0.280159C22.938 -0.0933857 23.5753 -0.0933858 23.9684 0.280159L35.25 11L23.9684 21.7198C23.5753 22.0934 22.938 22.0934 22.5448 21.7198Z",
    fill: "url(#paint2_linear_2063_28548)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2063_28548",
    x1: 35.5,
    y1: 11.0001,
    x2: 4.26956e-7,
    y2: 11.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FCBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2063_28548",
    x1: 36.0001,
    y1: 11.0002,
    x2: -0.5,
    y2: 11.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FCBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2063_28548",
    x1: 36,
    y1: 10.9999,
    x2: -3.36026e-7,
    y2: 11.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FCBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBF6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferArrows);
export default __webpack_public_path__ + "static/media/transferArrows.ad262dd30d41e0e150ece250f3ba35b6.svg";
export { ForwardRef as ReactComponent };